import { IconV1 } from 'common/icon/iconV1.js';
import { hasLegend } from 'components/legends/legend-types.js';
import { Legends } from 'components/legends/legends.js';
import { MarkerViewV2 } from 'components/map/marker-view/shared/pill-v2/marker-v2.js';
import { ScreenSizeContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { IMapKey, MapTags, MarkerDisplaySize } from 'types/location.js';
import { getMarkerVersionPosition, IMarker } from 'types/markerCore/marker-core-type.js';
import { isNotNullOrUndefined, predicateMarkerV1 } from 'utilities/isType.js';
import { isLargeView } from 'utilities/media-queries.js';
import { UseUpdateLocation } from 'utilities/router/router-updateLocation.js';
import { HTMLMarker } from '../../marker-view/shared/html/html-marker.js';
import { MapControls } from '../shared/map-control.js';

export type IStaticMapProps<T extends IMarker> = MapTags & {
  markers: T[];
  keys?: IMapKey[];
};

/** Only use export for use in Storybook  */
export const StaticMapCore = ({
  markers,
  keys,
  children,
  markerTags,
}: IStaticMapProps<IMarker> & { children: JSX.Element }) => {
  const isLarge = isLargeView(useContext(ScreenSizeContext));
  const navigate = useNavigate();
  const { onClick } = UseUpdateLocation();

  const nationalMarkers: IMarker[] = markers
    .map((marker) => {
      if (marker) {
        const staticPosition = getMarkerVersionPosition(marker).static;
        if (staticPosition?.left && staticPosition?.top) {
          return marker;
        }
      }
    })
    .filter(isNotNullOrUndefined);

  const showKey = hasLegend(keys);

  return (
    <div data-component="map-static" className="Map-container map-height--large-static">
      {showKey && (
        <div className="Map-container-overlay">
          <div className="map-controls ZoomControl--AbsolutePosition ZoomControl--right">
            <MapControls preventZoom={true}>
              <Legends keys={keys} />
            </MapControls>
          </div>
        </div>
      )}

      <div className="Map Map--primary Map--static">
        {children}
        <div className="Map-cartography">
          <div className="Map-cartography-image">
            <IconV1 icon="new-zealand-map" iconClass="Map-cartography-image-zIndex u-posRel" />
            {nationalMarkers.map((marker) => {
              if (predicateMarkerV1(marker)) {
                return <HTMLMarker key={marker.label} marker={marker} isLarge={isLarge} navigate={navigate} />;
              }
              return (
                <MarkerViewV2
                  marker={marker}
                  key={marker.key}
                  markerDisplaySize={MarkerDisplaySize.Large}
                  markerThemes={markerTags}
                  onClick={() => onClick(marker)}
                  // Used for map takeover
                  staticMarkerId={marker.label?.text?.toLowerCase().replace(' ', '-')}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
